<template>
  <v-app>
    <app-side-bar v-if="showNavs" />
    <app-header-menu v-if="showNavs" />
    <v-main class="accent">
      <router-view />
      <v-snackbar
        v-model="snackbar.showing"
        :color="snackbar.color"
        top
        right
        rounded="lg"
        elevation="8"
        class="app-snackbar"
      >
        <div class="tw-flex tw-items-center" style="gap: 10px">
          <v-icon color="white">{{ snackbarIcon }}</v-icon>
          <span class="app-snackbar-text">{{ snackbar.text }}</span>
          <v-spacer></v-spacer>
          <v-btn icon small color="white" @click="snackbar.showing = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    appSideBar: () => import('@/components/navigation/NavigationDrawer'),
    appHeaderMenu: () => import('@/components/navigation/HeaderMenu'),
  },
  computed: {
    ...mapState(['snackbar']),
    ...mapState({
      isAuthenticated: (state) => state.auth.idToken,
      showNavs() {
        return this.isAuthenticated && !this.$route.meta.noNavigation
      },
    }),
    snackbarIcon() {
      const color = (this.snackbar && this.snackbar.color) || ''
      if (color === 'success') return 'mdi-check-circle-outline'
      if (color === 'error') return 'mdi-alert-circle-outline'
      if (color === 'warning') return 'mdi-alert-outline'
      return 'mdi-information-outline'
    },
  },
}
</script>
<style lang="scss">
/* Soft-edged global toast */
.app-snackbar .v-snackbar__wrapper {
  border-radius: 14px !important;
  box-shadow: 0 12px 32px rgba(15, 42, 85, 0.28) !important;
  min-width: 300px;
}
.app-snackbar .app-snackbar-text {
  font-weight: 600;
  letter-spacing: 0.2px;
}

.v-sheet--offset {
  top: -25px;
  position: relative;
}

.v-sheet--offset .round-coners {
  border-radius: 5px;
}
</style>
